import {Event} from 'main.core';

class TabsManager {
    static instance = null;

    constructor(options = {}) {
        this.tabsLists = new Map();
    }

    addTabsList(tabsList) {
        if (!tabsList) {
            return;
        }

        const tabsListName = tabsList.getName();
        if (this.tabsLists.has(tabsListName)) {
            console.error('TabsList должны иметь уникальные имена');
            return;
        }

        this.tabsLists.set(tabsListName, tabsList);
    }

    getTabsList(tabsListName) {
        return this.tabsLists.get(tabsListName);
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new this({});
        }

        return this.instance;
    }

    static initTabs(element = document) {
        const tabsManager = this.getInstance();
        if (!tabsManager) {
            return;
        }

        element.querySelectorAll('[data-local-tabs-list]')
            .forEach((tabsListEl) => {
                const tabsListName = tabsListEl.dataset.localTabsList;

                let tabsList = new TabsList({
                    element: tabsListEl,
                });
                tabsManager.addTabsList(tabsList);

                tabsListEl.querySelectorAll('[data-local-tab]')
                    .forEach((tabEl) => {
                        tabsList.addTab(new Tab({
                            element: tabEl,
                        }));
                    });
            });
    }
}

class TabsList {
    constructor(options = {}) {
        this.el = options.element;
        this.tabs = [];
    }

    addTab(tab) {
        if (this.tabs.includes(tab)) {
            return;
        }

        tab.subscribe('select', this.onTabClick.bind(this));
        tab.setTabsList(this);
        this.tabs.push(tab);
    }

    getName() {
        return this.el.dataset.localTabsList;
    }

    getActiveClasses() {
        return this.el.dataset.tabsActiveClasses;
    }

    getInactiveClasses() {
        return this.el.dataset.tabsInactiveClasses;
    }

    async onTabClick(e) {
        const selectedTab = e.target;
        this.tabs.forEach((tab) => {
            if (tab == selectedTab) {
                tab.setActive(true);
            } else {
                tab.setActive(false);
            }
        });
    }
}

class Tab extends Event.EventEmitter {
    constructor(options = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Controls.Tab');

        this.el = options.element;
        this.tabList = null;
        this.el.addEventListener('click', this.onClick.bind(this));
    }

    getListName() {
        return this.el.dataset.localTab;
    }

    setTabsList(tabList) {
        this.tabList = tabList;
    }

    getTabsList() {
        return this.tabList;
    }

    isActive() {
        return Object.hasOwn(this.el.dataset, 'isActive')
    }

    setActive(value) {
        const changed = this.isActive() != value;
        if (value) {
            this.el.dataset.isActive = '';
            this.showBody();
        } else {
            delete this.el.dataset.isActive;
            this.hideBody();
        }
        if (changed) {
            this.updateClasses();
        }
    }

    getBodySelector() {
        return this.el.dataset.tabBodySelector;
    }

    getActiveClasses() {
        const classStr = this.getTabsList()?.getActiveClasses();
        if (!classStr) {
            return [];
        }

        return classStr.split(' ');
    }

    getInactiveClasses() {
        const classStr = this.getTabsList()?.getInactiveClasses();
        if (!classStr) {
            return [];
        }

        return classStr.split(' ');
    }

    updateClasses() {
        const activeClasses = this.getActiveClasses();
        const inactiveClasses = this.getInactiveClasses();

        if (activeClasses && inactiveClasses) {
            if (this.isActive()) {
                this.el.classList.remove.apply(this.el.classList, this.getInactiveClasses());
                this.el.classList.add.apply(this.el.classList, this.getActiveClasses());
            } else {
                this.el.classList.remove.apply(this.el.classList, this.getActiveClasses());
                this.el.classList.add.apply(this.el.classList, this.getInactiveClasses());
            }
        }
    }

    showBody() {
        const bodySelector = this.getBodySelector();
        if (!bodySelector) {
            return;
        }

        document.querySelectorAll(bodySelector)
            .forEach((bodyEl) => {
                bodyEl.classList.remove('hidden');
            });
    }

    hideBody() {
        const bodySelector = this.getBodySelector();
        if (!bodySelector) {
            return;
        }

        document.querySelectorAll(bodySelector)
            .forEach((bodyEl) => {
                bodyEl.classList.add('hidden');
            });
    }

    onClick(e) {
        this.emit('select', {
            sourceEvent: e,
        });
    }
}

BX.ready(() => {
    TabsManager.initTabs();
});

export {
    Tab,
    TabsList,
    TabsManager,
};